import { useState } from "react";
import TopupRegistrationHeadModal from "../../../pages/membership/slotsMembers/TopupRegistrationHeadModal";
import TopupRegistrationHeadModalAdditional from "../../../pages/membership/slotsMembers/TopupRegistrationHeadModalAdditional";

const RenewalScopeHeadDetails = (props) => {
    const [isTopupModal, setTopupModal] = useState(false);

    const [topupMode, setTopupMode] = useState(null);
    const [isTopupModalAdditional, setTopupModalAdditional] = useState(false);
    const openTopupModal = (mode) => {
        console.log("Child: opening modal with mode", mode); // Debug log
        setTopupMode(mode);
        setTopupModal(true);
        if (props.onModeChange) {
            props.onModeChange(mode);
        }
    };
    return (


        <div>
            <div className="grid grid-cols-12 gap-4 w-full justify-between mt-8">
                <div className="col-span-12">
                    <div className="flex justify-end lg:gap-6 gap-3">
                        <div className="lg:col-span-4 col-span-12 flex justify-end mt-[15px]">
                            <button
                                className={`btn btn-orange-border ${props.isDisabledFlag ? 'cursor-not-allowed' : null}`}
                                onClick={() => { setTopupModal(true); props.pricingCalculation() }}
                                disabled={props.isDisabledFlag ? true : false}
                            >
                                <span className="fa fa-plus"></span>
                                <span className="ml-2">Update Renewal Registration Head(s)</span>
                            </button>

                        </div>
                        {
                            props.SLOTSApplicationDetails.statusId === 4 ?
                                <>
                                    <div className=" lg:col-span-4  col-span-12 flex justify-end mt-[15px]">
                                        <button
                                            className={`btn btn-orange-border ${props.isDisabledFlag ? 'cursor-not-allowed' : null}`}
                                            onClick={() => { setTopupModalAdditional(true); props.pricingCalculationAdditional() }}
                                            disabled={props.isDisabledFlag ? true : false}
                                        >
                                            <span className="fa fa-plus"></span>
                                            <span className="ml-2">TopUp-Registration Head(s)</span>
                                        </button>
                                    </div>
                                </> : <></>
                        }
                    </div>

                </div>
            </div>


            <TopupRegistrationHeadModal
                isRenewal={props.isRenewal}
                TopupModal={isTopupModal}

                setOpenModal={() => setTopupModal(false)}

                SLOTSApplicationDetails={props.SLOTSApplicationDetails}

                mainGroupListPricing={props.mainGroupListPricing}
                workheadListPricing={props.workheadListPricing}

                selectedSLOTSRegistrationScope={props.selectedSLOTSRegistrationScope}
                validStateregistrationScope={props.validStateregistrationScope}

                handleChange={props.handleChange}
                handleChangeInDropdown={props.handleChangeInDropdown}

                currentPriceCalculatorArray={props.priceCalculatorArray}

                removeRegistrationHead={props.removeRegistrationHead}

                getSLOTSMemberDetailByMemberId={props.getSLOTSMemberDetailByMemberId}

                addSLOTSRenewalRegistrationHeadScope={props.addSLOTSRenewalRegistrationHeadScope}
                onClose={(e) => {
                    e.stopPropagation();
                    setTopupModal(false);
                    props.getSLOTSMemberDetailByMemberId(
                        props.SLOTSApplicationDetails.slotsMemberId
                    );
                }}
                removeRenewalRegistrationHead={props.removeRenewalRegistrationHead}
            />
            <TopupRegistrationHeadModalAdditional
                TopupModalAdditional={isTopupModalAdditional}

                setTopupModalAdditional={() => setTopupModalAdditional(false)}

                SLOTSApplicationDetails={props.SLOTSApplicationDetails}

                mainGroupListPricing={props.mainGroupListPricing}
                workheadListPricing={props.workheadListPricing}

                selectedSLOTSRegistrationScope={props.selectedSLOTSRegistrationScope}
                validStateregistrationScope={props.validStateregistrationScope}

                handleChange={props.handleChange}
                handleChangeInDropdown={props.handleChangeInDropdown}

                priceCalculatorArrayTopUpAdditional={props.priceCalculatorArrayTopUpAdditional}

                removeRegistrationHeadAdditional={props.removeRegistrationHeadAdditional}
                BuyAdditionalRegistrationHeadTopUp={props.BuyAdditionalRegistrationHeadTopUp}

                getSLOTSMemberDetailByMemberId={props.getSLOTSMemberDetailByMemberId}

                onClose={(e) => {
                    e.stopPropagation();
                    setTopupModalAdditional(false);
                    props.getSLOTSMemberDetailByMemberId(
                        props.SLOTSApplicationDetails.slotsMemberId
                    );
                }}
            />
        </div>
    );
}
export default RenewalScopeHeadDetails;
